var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ActionDialogLayout from '@/views/Groups/Tabs/Actions/Dialogs/ActionDialogLayout/ActionDialogLayout.vue';
import { Group } from '@/models/Group';
import SubjectSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/SubjectSelector/SubjectSelector.vue';
import StudentSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/StudentSelector/StudentSelector.vue';
import LabelValue from '@/components/LabelValue.vue';
import { UserSubject } from '@/models/UserSubject';
let CreatePlpDialog = class CreatePlpDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedStudents = {};
        this.selectedSubjects = [];
        this.selectedIdpType = null;
        this.currentStep = 1;
        // #endregion
    }
    get dialogOptions() {
        return {
            steps: [
                { label: this.$tc('Select students'), value: 1 },
                { label: this.$tc('Select PLP'), value: 2 },
                { label: this.$tc('createDialog.header.finished'), value: 3 },
            ],
            title: this.$tc('Add goals to PLP'),
            customButtons: [
                {
                    label: this.$tc('actions.add', 1),
                    action: () => {
                        this.create();
                    },
                    visible: this.currentStep === 3,
                    disabled: this.isDisabled,
                }
            ],
        };
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onClose() {
        this.$emit('close');
    }
    onSelectedStudents(value) {
        this.$set(this, 'selectedStudents', value);
    }
    onSelectedSubjects(value) {
        this.$set(this, 'selectedSubjects', value);
    }
    onCurrentStepChanged(value) {
        this.currentStep = value;
    }
    deleteSelectedSubject(index) {
        this.selectedSubjects.splice(index, 1);
    }
    onReset() {
        this.selectedStudents = {};
        this.selectedSubjects = [];
        this.selectedIdpType = null;
        this.currentStep = 1;
        this.$store.dispatch('selectedChanged', null);
    }
    // #endregion
    // #region Async methods (api calls only)
    create() {
        if (!this.selectedSubjects) {
            return;
        }
        const subjects = [];
        let users = [];
        this.selectedSubjects = this.$store.state.selected;
        this.selectedSubjects.forEach((selectedSubject) => {
            if (selectedSubject.id) {
                subjects.push(selectedSubject.id);
            }
        });
        Object.keys(this.selectedStudents).forEach(selectedStudent => {
            users = [...[selectedStudent], ...users];
        });
        const payload = {
            subjects,
            users,
            status: this.selectedIdpType,
        };
        new UserSubject()
            .bulkUpdateSubjectToStudents(payload)
            .then(() => {
            this.onReset();
            this.$emit('submitted');
        });
    }
    // #endregion
    // #region Getters & Setters
    get isDisabled() {
        switch (this.currentStep) {
            case 1:
                return Object.keys(this.selectedStudents).every((key) => {
                    return this.selectedStudents[key] === false;
                }) || Object.keys(this.selectedStudents).length === 0;
            case 2:
                return this.selectedSubjects.length === 0;
            case 3:
                return this.selectedIdpType === null || this.selectedSubjects.length === 0;
            default:
                return false;
        }
    }
    get selectedSubjectsFromStore() {
        return this.$store.state.selected;
    }
    // #endregion
    // #region @Watchers
    onSelectedSubjectsChanged(value) {
        this.$set(this, 'selectedSubjects', value);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], CreatePlpDialog.prototype, "group", void 0);
__decorate([
    Watch('selectedSubjectsFromStore'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], CreatePlpDialog.prototype, "onSelectedSubjectsChanged", null);
CreatePlpDialog = __decorate([
    Component({
        components: {
            ActionDialogLayout,
            SubjectSelector,
            StudentSelector,
            LabelValue,
        }
    })
], CreatePlpDialog);
export default CreatePlpDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
